import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';
import { Divider } from '@uhg-abyss/web/ui/Divider';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';

import { phoneOnly } from '../ConstantsStyles';
import { CTAContent, CTAText } from './CareTeamProviderCard.styled';

export const CTAButton = ({
  icon,
  label,
  onClick,
  autoTestId,
  'data-testid': dataTestId,
  networkStatus,
  newTabIcon,
}: {
  icon: string;
  label: string;
  autoTestId: string;
  'data-testid'?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  networkStatus?: boolean;
  newTabIcon?: string;
}) => {
  const mobileScreen = useMediaQuery(phoneOnly);
  const directionsIconSize = 22;
  return (
    <CTAContent
      css={{
        color: networkStatus ? '#ccc' : 'inherit',
        cursor: networkStatus ? 'not-allowed' : 'pointer',
      }}
      data-auto-testid={autoTestId}
      data-testid={dataTestId}
      disabled={networkStatus}
      onClick={(event) => {
        event.stopPropagation();
        if (onClick) {
          onClick(event);
        }
      }}
    >
      <Flex alignItems="center" direction="column">
        <IconSymbol
          color={networkStatus ? '#CBCCCD' : '$core.color.brand.60'}
          icon={icon}
          size={mobileScreen ? 'sm' : directionsIconSize}
          variant="outlined"
        />
        <CTAText
          css={{
            '&': {
              color: networkStatus ? '#CBCCCD' : '$core.color.brand.60',
            },
          }}
        >
          <Flex alignItems="center">
            {label}
            {newTabIcon && (
              <IconSymbol
                color={networkStatus ? '#CBCCCD' : '$core.color.brand.60'}
                icon={newTabIcon}
                size="16"
                style={{ marginLeft: '4px' }}
              />
            )}
          </Flex>
        </CTAText>
      </Flex>
    </CTAContent>
  );
};

export const VerticalDivider = () => (
  <Divider height="42px" orientation="vertical" width="1px" />
);
